// extracted by mini-css-extract-plugin
export var indexSubTitle = "Index-module--indexSubTitle--rtb-t";
export var indexViewMarketplaceButton = "Index-module--indexViewMarketplaceButton--ZdOqb";